import React, { useState, useEffect } from 'react';
import logo from '../assets/Generallogo.png';
import { FaDownload, FaTimes } from 'react-icons/fa';

const InstallPWA = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        console.log('InstallPWA component mounted');

        const handleBeforeInstallPrompt = (e) => {
            console.log('beforeinstallprompt event fired!');
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event so it can be triggered later.
            setDeferredPrompt(e);

            // Show the modal if it hasn't been dismissed in this session
            const isDismissed = sessionStorage.getItem('pwaPromptDismissed');
            console.log('PWA prompt dismissed?', isDismissed);
            if (!isDismissed) {
                // Delay showing to not overwhelm on first land
                console.log('Will show PWA modal in 3 seconds...');
                setTimeout(() => {
                    console.log('Showing PWA modal now!');
                    setShowModal(true);
                }, 3000);
            }
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        window.addEventListener('appinstalled', () => {
            setDeferredPrompt(null);
            setShowModal(false);
            console.log('PWA was installed');
        });

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;

        // Show the install prompt
        deferredPrompt.prompt();

        // Wait for the user to respond to the prompt
        const { outcome } = await deferredPrompt.userChoice;
        console.log(`User response to the install prompt: ${outcome}`);

        // We've used the prompt, and can't use it again, throw it away
        setDeferredPrompt(null);
        setShowModal(false);
    };

    const handleDismiss = () => {
        setShowModal(false);
        // Don't show again in this session
        sessionStorage.setItem('pwaPromptDismissed', 'true');
    };

    if (!showModal) return null;

    return (
        <div className="pwa-install-overlay">
            <div className="pwa-install-modal">
                <button className="pwa-close-btn" onClick={handleDismiss}>
                    <FaTimes />
                </button>

                <div className="pwa-modal-content text-center">
                    <div className="pwa-logo-wrapper mb-4 d-flex flex-column align-items-center">
                        <div className="pwa-logo-glow"></div>
                        <span className="pwa-logo-text" style={{ 
                            fontWeight: '700', 
                            color: '#fff', 
                            letterSpacing: '2px',
                            fontSize: '1.2rem',
                            textTransform: 'uppercase',
                            fontFamily: 'Outfit, sans-serif',
                            lineHeight: '1'
                        }}>
                            AL WASEEQ DESIGN
                        </span>
                        <span className="pwa-tagline" style={{
                            fontSize: '0.45rem',
                            color: '#fff',
                            letterSpacing: '2px',
                            fontWeight: '400',
                            textTransform: 'uppercase',
                            marginTop: '5px',
                            opacity: '0.5'
                        }}>
                            We Craft Your Dream World
                        </span>
                    </div>

                    <h2 className="pwa-title mb-2">EXPERIENCE THE VISION</h2>
                    <p className="pwa-text mb-4">
                        Install Al-Waseeq Design for a faster, premium experience directly on your device.
                    </p>

                    <div className="d-flex flex-column gap-3">
                        <button className="btn-install-pwa" onClick={handleInstallClick}>
                            <FaDownload className="me-2" /> INSTALL APP
                        </button>
                        <button className="btn-later-pwa" onClick={handleDismiss}>
                            MAYBE LATER
                        </button>
                    </div>
                </div>

                <div className="pwa-modal-accent"></div>
            </div>

            <style>{`
                .pwa-install-overlay {
                    position: fixed;
                    inset: 0;
                    background: rgba(0, 0, 0, 0.85);
                    backdrop-filter: blur(8px);
                    z-index: 9999;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 20px;
                    animation: fadeIn 0.4s ease;
                }

                .pwa-install-modal {
                    background: #0a0a0a;
                    border: 1px solid rgba(197, 160, 89, 0.2);
                    padding: 40px 30px;
                    border-radius: 4px;
                    max-width: 400px;
                    width: 100%;
                    position: relative;
                    overflow: hidden;
                    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
                    animation: modalSlideUp 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
                }

                .pwa-modal-accent {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 4px;
                    height: 100%;
                    background: var(--secondary-color);
                }

                .pwa-close-btn {
                    position: absolute;
                    top: 15px;
                    right: 15px;
                    background: none;
                    border: none;
                    color: rgba(255, 255, 255, 0.3);
                    font-size: 1.2rem;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    z-index: 2;
                }

                .pwa-close-btn:hover {
                    color: #fff;
                    transform: rotate(90deg);
                }

                .pwa-logo-wrapper {
                    position: relative;
                    display: inline-block;
                }

                .pwa-logo-glow {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 120%;
                    height: 120%;
                    background: radial-gradient(circle, rgba(197, 160, 89, 0.1) 0%, transparent 70%);
                    z-index: -1;
                }

                .pwa-logo {
                    height: 60px;
                    filter: brightness(1.1);
                }

                .pwa-title {
                    color: #fff;
                    font-size: 1.1rem;
                    letter-spacing: 4px;
                    font-weight: 700;
                }

                .pwa-text {
                    color: rgba(255, 255, 255, 0.5);
                    font-size: 0.85rem;
                    line-height: 1.6;
                    font-weight: 300;
                }

                .btn-install-pwa {
                    background: var(--secondary-color);
                    color: #000;
                    border: none;
                    padding: 14px;
                    font-size: 0.8rem;
                    font-weight: 700;
                    letter-spacing: 2px;
                    border-radius: 2px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }

                .btn-install-pwa:hover {
                    background: #fff;
                    transform: translateY(-2px);
                    box-shadow: 0 5px 15px rgba(197, 160, 89, 0.2);
                }

                .btn-later-pwa {
                    background: transparent;
                    color: rgba(255, 255, 255, 0.4);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    padding: 12px;
                    font-size: 0.75rem;
                    font-weight: 500;
                    letter-spacing: 2px;
                    border-radius: 2px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }

                .btn-later-pwa:hover {
                    color: #fff;
                    background: rgba(255, 255, 255, 0.05);
                    border-color: rgba(255, 255, 255, 0.3);
                }

                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @keyframes modalSlideUp {
                    from { opacity: 0; transform: translateY(30px); }
                    to { opacity: 1; transform: translateY(0); }
                }

                @media (max-width: 576px) {
                    .pwa-install-modal {
                        padding: 35px 20px;
                    }
                }
            `}</style>
        </div>
    );
};

export default InstallPWA;
